import React from 'react';
import {Form} from 'semantic-ui-react'

const ConfLubricante1 = ({styles, handleClickRegr, args, handleSubmit, handleChange}) => {
  if(args.descrFabricante){
    var descrFabricante = document.getElementById("descrFabricante");
    if(descrFabricante){descrFabricante.value = args.descrFabricante}
  }
  if(args.descrLubricante){
    var descrLubricante = document.getElementById("descrLubricante");
    if(descrLubricante){descrLubricante.value = args.descrLubricante}
  }
  return (
    <div>
      <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
        <div>
          <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
          <i className="large search yellow icon"></i>
            Buscar
          </button>
          <div className="ui input fluid">
            <input id='descrFabricante' autoComplete="off" name="descrFabricante" type="text" placeholder="Marca" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrLubricante' autoComplete="off" name="descrLubricante" type="text" placeholder="Lubricante" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <p></p>
          <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
            <i className="large sitemap yellow icon"></i>
            Opciones
          </button>

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
            <i className="large arrow left violet icon"></i>
            Regresar
          </button>
        </div>
      </Form>
    </div>
  )
};

export default ConfLubricante1
